/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import { Box, Text, Flex } from "@chakra-ui/react";
import { getContextMenuPosition } from "utils/contextMenuPosition";

function TelemetriContextMenu({
  position,
  data,
  onClose,
  onOpenGelenData,
  onOpenGelenUetdsData,
  onOpenKomutModal,
  onOpenKmSetModal,
  onGatherSim,
  showUetdsRawlogs = false,
}) {
  if (!position) return null;
  const menuPosition = getContextMenuPosition(position, { menuWidth: 228, menuHeight: showUetdsRawlogs ? 300 : 260 });

  return (
    <Box
      position="fixed"
      top={`${menuPosition.y}px`}
      left={`${menuPosition.x}px`}
      bg="white"
      borderRadius="lg"
      shadow="0 4px 12px rgba(0, 0, 0, 0.15)"
      zIndex={2000}
      onMouseLeave={onClose}
      minW="140px"
      fontSize="11px"
      py={1}
    >
      <MenuItem label="SIM No Getir" onClick={() => { onGatherSim?.(data); onClose(); }} />
      <MenuItem label="Serbest Komut Gönder" onClick={() => { onOpenKomutModal?.(data); onClose(); }} />
      <MenuItem label="Toplu Komut Gönder" onClick={() => { alert(`Toplu: ${data?.plaka}`); onClose(); }} />
      <MenuItem label="KM Set Et" onClick={() => { onOpenKmSetModal?.(data); onClose(); }} />
      <MenuItem label="Gelen Data" onClick={() => { onOpenGelenData?.(data?.imei, data); onClose(); }} />
      {showUetdsRawlogs ? (
        <MenuItem
          label="Gelen UETDS data"
          onClick={() => {
            onOpenGelenUetdsData?.(data);
            onClose();
          }}
        />
      ) : null}
    </Box>
  );
}

function MenuItem({ label, onClick }) {
  return (
    <Flex
      align="center"
      px={3}
      py={1.5}
      cursor="pointer"
      borderRadius="md"
      mx={1}
      transition="all 0.15s ease"
      _hover={{ bg: "gray.50", color: "gray.900", transform: "scale(1.02)" }}
      onClick={onClick}
    >
      <Text fontWeight="500" color="gray.600" fontSize="11px">{label}</Text>
    </Flex>
  );
}

export default TelemetriContextMenu;
